












































































































import {Component, Vue, Watch} from "vue-property-decorator";
import moment from 'moment'
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import DispositionPicker from "@/view/shared-components/DispositionPicker.vue";
import TicketService from "@/services/TicketService";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import SearchHold from "@/domainObjects/hold/SearchHold";
import DefectPicker from "@/view/shared-components/DefectPicker.vue";
import VerificationPicker from "@/view/shared-components/VerificationPicker.vue";
import SubmitTicketButtonGroupMobile from "@/view/shared-components/mobile-only/SubmitTicketButtonGroupMobile.vue";
import SubmitTicketButtonGroupDesktop from "@/view/shared-components/desktop-only/SubmitTicketButtonGroupDesktop.vue";
import {mapGetters} from "vuex";
import StatusPicker from "@/view/shared-components/StatusPicker.vue";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
import CustomDatePicker from "@/view/shared-components/CustomDatePicker.vue";


@Component({
    name:'SearchHoldTicketPage',
    components: {
        CustomDatePicker,
        LoadingIndicator,
        StatusPicker,
        SubmitTicketButtonGroupDesktop,
        SubmitTicketButtonGroupMobile,
        VerificationPicker,
        DefectPicker,
        DispositionPicker,
        PlantPicker,
    },
    computed: {
        ...mapGetters(['getGroups']),
    }
})
export default class SearchHoldTicketPage extends Vue {

    holdTickets: HoldTicket[] = [];
    private show: boolean = true;
    search: SearchHold;
    originalSearchStringified: string;
    busy: boolean = false;
    error: string = '';
    allowReset: boolean = false;
    unsecureServerUrl: string = '';
    downloading: boolean = false;

    @Watch('search',{immediate:true, deep:true})
    onPropertyChanged (value: SearchHold, oldvalue: SearchHold) {
        let searchStringified = JSON.stringify(value);
        this.allowReset = this.originalSearchStringified !== searchStringified;
    }

    constructor(){
        super();
        this.unsecureServerUrl = TicketService.getUnsecureServerUrl();
        this.search = new SearchHold();
        this.originalSearchStringified = JSON.stringify(this.search);
    }

    onSubmit() {
        this.search.limitResults = true;
        this.busy = true;
        this.error = '';
        if (!this.search.statuses.includes(7)){
            this.search.closedStartDate = "";
            this.search.closedEndDate = "";
        }
        let searchJSON = JSON.stringify(this.search);
        this.$router.push({name:'hold-search-results', params: { searchJSON: searchJSON }})
    };

    onReset() {
        this.show = false;
        this.search = new SearchHold();
        this.$nextTick(() => {
            this.show = true
        });
        this.error = '';
    }

    selectClosedDateRange(months){
        this.show = false;
        this.search.closedStartDate = new Date(moment().subtract(months, 'month').toDate());
        this.search.closedEndDate = new Date();
        this.$nextTick(() => {
            this.show = true
        });
    }

    selectCreateDateRange(months){
        this.show = false;
        this.search.createdStartDate = new Date(moment().subtract(months, 'month').toDate());
        this.search.createdEndDate = new Date();
        this.$nextTick(() => {
            this.show = true
        });
    }

    openCsvFile(result, csvFileName){
        if (window.navigator.msSaveBlob) {
            //Internet Explorer
            window.navigator.msSaveBlob(new Blob([result]), csvFileName);
            // @ts-ignore
        } else if (window.webkitURL != null) {
            //Google Chrome and Mozilla Firefox
            let a = document.createElement("a");
            result = encodeURIComponent(result);
            a.href = "data:application/csv;charset=UTF-8," + result;
            a.download = csvFileName;
            a.click();
        } else {
            //Everything Else
            window.open(result);
        }
    }

    generateHoldExcelReport(){
        this.downloading = true;
        this.search.limitResults = false;
        let searchJSON = JSON.stringify(this.search);
        TicketService.generateHoldExcelReport(searchJSON).then((response)=>{
            this.openCsvFile(response.data, "HoldTicketSearchResults.csv");
            this.downloading = false;
        }).catch((error) => {
            this.$router.push('/search-hold-ticket')
            alert('error downloading excel file, search criteria may be malformed');
        });
    }
}
